
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as gmMZ5Icj_65lUxONJyyZmgKGrnf4IsOeW_QiOjcsnZEoMeta } from "/codebuild/output/src1931888890/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue?macro=true";
import { default as indexMsNVyPh3lGXzmE2_45DjVlB0q5vRePP7DageuGf_zxtdgMeta } from "/codebuild/output/src1931888890/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue?macro=true";
import { default as searchUCW8u1sqzdf6wX3SePkDcpV7ZIJCO8KTr2NsETEgpMIMeta } from "/codebuild/output/src1931888890/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue?macro=true";
import { default as indexUFt_45QNS4I4YHxyPMLObW3eg0dqASzEtVISAkP_45drVwkMeta } from "/codebuild/output/src1931888890/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue?macro=true";
import { default as _91id_93AYwSq_LdxG9tBAArU8uZ0_45IUKXEnFbiBuDtgWu53x3wMeta } from "/codebuild/output/src1931888890/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue?macro=true";
import { default as index5BLWOXZrrJIYBmtcvhIBKm_RQ9ob33r4_xE5cOx7pKAMeta } from "/codebuild/output/src1931888890/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue?macro=true";
import { default as _91id_93icHkjFtXwQp8sdELg9_vqFzaZVF4WpYnV86mBu_VI_45AMeta } from "/codebuild/output/src1931888890/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue?macro=true";
import { default as indexyStSmUrJSgkSqjghetQtHag9G18pCS_45soZFqZcRPDKkMeta } from "/codebuild/output/src1931888890/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue?macro=true";
import { default as _91id_93rvL4Y_45P1_0YM5hCVv6xRqvQZzStYEmAGsMeNlab26qwMeta } from "/codebuild/output/src1931888890/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue?macro=true";
import { default as indexbkZSqkJ_ebuoZ_xymAInlQimQe7Jfqd07SNd7m31sUsMeta } from "/codebuild/output/src1931888890/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as indexi7j8POFBmynut9pn_45yIrgnlvgYIdJso5SQGXmAwiMYMMeta } from "/codebuild/output/src1931888890/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue?macro=true";
export default [
  {
    name: "g",
    path: "/g",
    component: () => import("/codebuild/output/src1931888890/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src1931888890/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src1931888890/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue")
  },
  {
    name: "v8",
    path: "/v8",
    component: () => import("/codebuild/output/src1931888890/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/codebuild/output/src1931888890/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: index5BLWOXZrrJIYBmtcvhIBKm_RQ9ob33r4_xE5cOx7pKAMeta || {},
    component: () => import("/codebuild/output/src1931888890/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/codebuild/output/src1931888890/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: indexyStSmUrJSgkSqjghetQtHag9G18pCS_45soZFqZcRPDKkMeta || {},
    component: () => import("/codebuild/output/src1931888890/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue")
  },
  {
    name: "v8-article-id",
    path: "/v8/article/:id()",
    component: () => import("/codebuild/output/src1931888890/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: indexbkZSqkJ_ebuoZ_xymAInlQimQe7Jfqd07SNd7m31sUsMeta || {},
    component: () => import("/codebuild/output/src1931888890/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy-relationships",
    path: "/privacy-policy/relationships",
    meta: indexi7j8POFBmynut9pn_45yIrgnlvgYIdJso5SQGXmAwiMYMMeta || {},
    component: () => import("/codebuild/output/src1931888890/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue")
  }
]